<template>
<div class="shadow-box">
  <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0; margin-right: 0;">
    <span>专属商品报单用户</span>
    <span></span>
  </div>
  <div class="page-main_box">
    <div class="flex-row search-box">
      <div class="search-item">
        <div class="label">状态：</div>
        <el-select clearable v-model="form.forbidFlag" @change="getList" placeholder="选择状态">
          <el-option :value="''" label="全部"></el-option>
          <el-option :value="1" label="正常"></el-option>
          <el-option :value="0" label="拉黑"></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <div class="label">用户ID：</div>
        <el-input v-model="form.qdAccountId" @blur="getList" @clear="getList" clearable placeholder="请输入用户ID"></el-input>
      </div>
      <div class="search-item">
        <div class="label">微信昵称：</div>
        <el-input v-model="form.nickname" @blur="getList" @clear="getList" clearable placeholder="请输入微信昵称"></el-input>
      </div>
      <el-button type="primary" @click="getList">查 询</el-button>
    </div>
    <div class="code-list-content">
      <el-table
        row-key="id"
        border
        stripe
        default-expand-all
        style="width: calc(100vw - 290px);"
        height="calc(100vh - 260px)"
        :data="tableData"
        v-loading="isLoading" >
        <el-table-column
          prop="qdAccountId"
          label="用户ID"
          min-width="80">
        </el-table-column>
        <!-- <el-table-column
          prop="openId"
          label="微信openid"
          min-width="120"> 
        </el-table-column> -->
        <el-table-column
          prop="nickname"
          label="微信昵称"
          min-width="120"> 
        </el-table-column>
        <el-table-column
          prop="headImgUrl"
          label="用户头像"
          min-width="120">
          <template slot-scope="{ row }">
            <div>
              <el-avatar v-if="row.headImgUrl" shape="square" :size="40" fit="cover" :src="row.headImgUrl"></el-avatar>
              <el-avatar v-else :size="40" icon="el-icon-user-solid"></el-avatar>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="qdNickName"
          label="归属渠道"
          min-width="120"> 
        </el-table-column>
        <el-table-column
          prop="forbidFlag"
          label="状态"
          show-overflow-tooltip
          min-width="140">
          <!-- 是否拉黑 0-拉黑，1-正常 -->
          <template slot-scope="{ row }">
            <div>
              <el-tag type="primary" v-if="row.forbidFlag == 1">正常</el-tag>
              <el-tag v-else-if="row.forbidFlag == 0">拉黑</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="firstLoginDate"
          label="首次登录时间"
          show-overflow-tooltip
          min-width="160"></el-table-column> 
        <el-table-column
          prop="lastLoginDate"
          label="最近登录时间"
          show-overflow-tooltip
          min-width="160">
        </el-table-column> 
        <el-table-column
          prop="lastBdDate"
          label="最近报单时间"
          show-overflow-tooltip
          min-width="160">
          <template slot-scope="{ row }">
            <div>
              {{ row.lastBdDate | filterDate }}
            </div>
          </template>
        </el-table-column> 
        <el-table-column
          fixed="right"
          label="操作"
          width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="flagChange(row)">{{ row.forbidFlag == 1 ? '拉黑' : '取消拉黑'}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="bd--pag">
        <el-pagination
          class="d-ib"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          :page-sizes="pageInfo.sizes"
          :page-size="pageInfo.size"
          :current-page="pageInfo.current"
          @current-change="pageInfo.current = arguments[ 0 ], getList()"
          @size-change="pageInfo.size = arguments[ 0 ], getList()">
        </el-pagination>
      </div> 
    </div>
  </div>

  <!-- 新增/修改 -->
  <createDrawer
    v-if="showCreateDrawer"
    v-model="showCreateDrawer"
    :editRow="editRow"
    :parentDepart="parentDepart"
    @close="showCreateDrawer = false"
    @on-success="successHandler"
  ></createDrawer>

</div>
</template>
<script>
import createDrawer from '@/page/component/sections/team/account-drawer'
import { queryQdAccountMapPage, updateForbidFlag } from '@/service/apis/order'
const dayjs = require('dayjs')

export default {
  components: { 
    createDrawer
   },
  data () {
    return {
      form: {
        forbidFlag: '',
        qdAccountId: '',
        nickname: ''
      },
      pageInfo: {
        current: 1,
        size: 10,
        sizes: [ 10, 20, 30, 50, 100 ],
        pages: 0,
        total: 0
      },
      isLoading: false,
      tableData: [],
      editRow: null,
      parentDepart: null,
      showCreateDrawer: false
    }
  },
  filters: {
    filterDate (date) {
      if (date) {
        return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
      }
      return ''
    }
  },
  created () {
    this.$nextTick(() => {
      this.getList()
    })
  },
  methods: {
    flagChange (row) {
      const loading = this.$loading({
        lock: true,
        text: '更新中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      updateForbidFlag.call(this, {
        idList: [row.id],
        forbidFlag: row.forbidFlag == 1 ? 0 : 1
      }).then(res => {
        if (res) {
          this.getList()
          this.$message.success('更新状态成功')
        }
      }).finally(() => {
        loading.close()
      })
    },
    getList () { 
      this.isLoading = true
      this.tableData = []
      queryQdAccountMapPage.call(this, {
        ...this.form,
        pageIndex: this.pageInfo.current,
        pageSize: this.pageInfo.size,
        reportTypeList: 'ZS'
      }).then((res) => {
        const {records, pages, total} = res
        this.pageInfo.total = total || 0
        this.pageInfo.pages = pages || 0
        this.tableData = [...(records || [])]
      }).finally(() => {
        this.isLoading = false
      })
    },
    // 新增、修改回调
    successHandler () {
      this.showCreateDrawer = false
      this.getList()
    }
  }
}
</script>

<style scoped>
</style>
